import { RootState } from '@store/redux/reducers'

export function getCustomerFitCondensed(state: RootState) {
  const { fit, updatedAt } = state.customerFit || {}
  return { fit: { ...fit?.top, ...fit?.bottom }, updatedAt }
}
